(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-saving-services"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".fall-saving-services .swiper-container").forEach(function (container) {
    new Swiper(container, {
      initialSlide: 0,
      centeredSlides: false,

      slidesPerView: 1.2,
      spaceBetween: 15,

      slidesOffsetBefore: 15,   // ✅ IMPORTANT: pushes first card into view
      slidesOffsetAfter: 15,    // ✅ keeps last card spacing balanced

      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: 1.2,
          spaceBetween: 15,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15
        },
        769: {
          enabled: false,
          slidesPerView: 4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
